import React from 'react';
import { useTranslation } from 'react-i18next';
import useWizard from '../hooks/useWizard';
import { WizardStepModel } from '../models/WizardStepModel';

export const WizardHeader: React.FC<WizardHeaderProps> = (props) => {
    const wizardHook = useWizard();
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-2">
            <div className="relative">
                <s-heading>{t('DASHBOARD.STEP_GUIDE.TITLE')}</s-heading>
                <div className="hover-reveal absolute right-0 top-0">
                    <s-button
                        icon="x"
                        onClick={wizardHook.doneAllSteps}
                        variant="tertiary"
                        accessibilityLabel="Skip wizard"
                    />
                </div>
            </div>
            <s-text color="subdued">{props.subtitle}</s-text>
            <div className="flex flex-row">
                <div className="border border-border px-2 rounded-2xl">
                    <span className="text-body-sm font-bold! text-text-subdued">
                        {t('WIZARD.PROGRESS', {
                            done_steps: wizardHook.countCompletedSteps(),
                            all_steps: props.steps.length,
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

type WizardHeaderProps = {
    subtitle: React.ReactNode;
    steps: WizardStepModel[];
};
